/* eslint-disable complexity */
import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import styles from "~/components/CaseButton/index.module.css"
import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"

export const RouterLink = ({ children, className, href, as, activeClassName, ...props }) => {
  let aHref = `${as || href}`
  const isLocation = typeof location !== "undefined"

  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  const domain = currLang === "en" ? "com" : "ru"

  if (aHref.startsWith("/") && isLocation) {
    const isOrigin =
      /:\d+$/.test(location.host) ||
      location.host === `beaversbrothers.${domain}` ||
      location.host === `test.beaversbrothers.${domain}` ||
      location.host === `dabb.pro`

    if (!isOrigin) {
      aHref = currLang === "en" ? `dabb.pro${aHref}` : `https://beaversbrothers.${domain}${aHref}`
    }
  }

  const isActive = isLocation ? location.pathname === aHref : false

  if (
    !aHref.includes("beaversbrothers.ru") &&
    !aHref.includes("beaversbrothers.com") &&
    !aHref.includes("dabb.pro") &&
    !aHref.startsWith("/")
  ) {
    return (
      <a
        className={cn(className, {
          [activeClassName]: activeClassName && isActive,
        })}
        href={aHref}
        rel="noopener noreferrer"
        target={"_blank"}
        {...props}
      >
        {children}
      </a>
    )
  }

  return (
    <a
      className={cn(className, {
        [activeClassName]: activeClassName && isActive,
      })}
      href={aHref}
      {...props}
    >
      {children}
    </a>
  )
}
